module.exports = __webpack_public_path__ + "../front/img/468_hylder+bøjlestang.9512c198.svg";